import { useChatContext } from '@/contexts/ChatContext';

export default function DashboardTopbar() {
  const { selectedProjectId, selectedChatId, getCurrentAgent, getCurrentChat } = useChatContext();
  const agent = getCurrentAgent();
  const chat = getCurrentChat();

  const title = selectedChatId ? chat?.title : 'Nova conversa';
  const subtitle = selectedProjectId
    ? (agent?.name ? `Space: ${agent.name}` : 'Space selecionado')
    : '';

  return (
    <header className="relative min-h-[53px] py-2 shrink-0 bg-white dark:bg-[#18181b] theme-border border-b theme-border/80">
      <div className="h-full px-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="min-w-0">
            <div className="text-sm font-semibold theme-text truncate">
              {title}
            </div>
            {subtitle && (
              <div className="text-xs theme-text-muted truncate">
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

